








import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({ components: { AdminIframe, PageTitle} })
export default class SkinBannersAdd extends Vue {
  private get remoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + this.$route.path + '?' + queryString;
    return src;
  }
}
